import React from 'react'
import {TransitionMotion, spring, presets} from 'react-motion';

const springConfig = {stiffness: 300, damping: 50};

class SlidingLines extends React.Component {
    willEnter() {
        return {
          // padding:0,
          opacity: 0,
          height: 0,
          h1Height: 0,
          // offset: -100,
          // scale: spring(1, springConfig),
          //       shadow: spring(1, springConfig),
          //       y: spring(1, springConfig)
        }
    }
    willLeave(){
      return {
        // padding: 0,
        height: spring(0),
        h1Height: spring(0),
        opacity: spring(0),
        // offset: -100,
        // scale: spring(1, springConfig),
        //       shadow: spring(1, springConfig),
        //       y: spring(1, springConfig)
      }
    }
    render() {
        let { data } = this.props;
        return (
            <div>
                <TransitionMotion
                  styles={this.props.data.map((c, i) => {
                      return {
                        key: c.token_id,
                        style: {
                          height: spring( (this.props.height||300) +(c.isSameDate?0:36), springConfig),
                          h1Height: spring(36, springConfig),
                          opacity: spring(1, springConfig),
                          // scale: spring(0, springConfig),
                          // offset: spring(0, springConfig),
                          //         shadow: spring(16, springConfig),
                          //         y: spring(1 * 100, springConfig)
                        },
                          data: c
                      }
                  })}
                  willEnter={this.willEnter}
                  willLeave={this.willLeave}>
                  {
                    this.props.children
                  }
                </TransitionMotion>
            </div>
        )
    }
}



export default SlidingLines



// WEBPACK FOOTER //
// ./src/core/SlidingLines.js